// extracted by mini-css-extract-plugin
module.exports = {"banner":"speakers_banner__2dY0c","btn":"speakers_btn__sl6Zp","itemsOnImg":"speakers_itemsOnImg__3sYKk"};